import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle } from 'lucide-react';
export function OldMethods() {
  const methods = [{
    title: 'Las "Reparadoras" Tradicionales',
    desc: 'Te cobran $100 al mes solo por enviar una carta genérica, alargando el proceso intencionalmente para sacarte más dinero mes a mes.'
  }, {
    title: 'Llamar a los Burós',
    desc: 'Ignoran tus llamadas y te dan excusas porque saben que no conoces las leyes federales FCRA actualizadas a 2026 para defenderte.'
  }, {
    title: 'Depender de Credit Karma',
    desc: 'Te da una falsa sensación de seguridad, pero los bancos miran reportes mucho más profundos y estrictos que tú ni siquiera has visto.'
  }];
  return <SectionWrapper className="bg-brand-darker" data-id="element-129">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-130">
        <div className="text-center mb-12" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-display uppercase mb-4" data-id="element-132">
            Por qué lo que intentaste{' '}
            <span className="text-red-500" data-id="element-133">no funcionó</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-134">
            El juego está arreglado en tu contra si sigues usando las reglas del
            pasado.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-135">
          {methods.map((method, idx) => <div key={idx} className="bg-brand-card border border-gray-800 rounded-xl p-8 relative overflow-hidden group hover:border-red-500/30 transition-colors" data-id="element-136">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-137">
                <XCircle className="w-24 h-24 text-red-500" data-id="element-138" />
              </div>
              <XCircle className="w-8 h-8 text-red-500 mb-6 relative z-10" data-id="element-139" />
              <h3 className="text-xl font-bold text-white mb-3 relative z-10" data-id="element-140">
                {method.title}
              </h3>
              <p className="text-gray-400 relative z-10 leading-relaxed" data-id="element-141">
                {method.desc}
              </p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}